/* eslint-disable no-unused-vars */
const listOfPermissionsAvailable = (permissions) =>
  // const permissionsList = [
  //     "dashboard",
  //     "lead_search",
  //     "lead_search_all",
  //     "lead_search_admin",
  //     "lead_search_result_download",
  //     "lead_search_all_result_download",
  //     "lead_detailed_view",
  //     "lead_detailed_view_all",
  //     "lead_detailed_view_admin",
  //     "lead_edit",
  //     "lead_edit_all",
  //     "lead_summary_view",
  //     "merchant-individual",
  //     "service_agent_upload",
  //     "ivr_status_upload",
  //     "calling_status_upload",
  //     "lead_search_ppb",
  //     "kyc_book_appointment"
  // ];
  // for (let index in permissionsList) {
  //     if (permissions.indexOf(permissionsList[index]) > -1) {
  //         return true;
  //     };
  // }
  // return false;
  true;
export default listOfPermissionsAvailable;
